import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ExtendedLink from "./ExtendedLink";
import Image from "./Image";

export default function (props) {
    const { t } = useTranslation();

    const group = props.group;
    if (!group) return <div />;
    const colsClass = `col-sm-${props.smCols} col-md-${props.mdCols} mb-30`;
    const groupsLink = `${props.baseUrl}categories/${group.id}`;
    return (
        <div className={colsClass}>
            <div className="card h-100">
                <ExtendedLink
                    to={groupsLink}
                    className="card-img-tiles"
                    href="shop-grid-ns.html"
                >
                    <div className="inner">
                        <div className="main-img">
                            <Image src={group.pic1 ? group.pic1 : "img/no-image.jpg"}
                                fallbackSrc="img/no-image.jpg" alt={group.name} />
                            {/*<img*/}
                            {/*    src={group.pic1 ? group.pic1 : "img/no-image.jpg"}*/}
                            {/*    alt={group.name} />*/}
                        </div>
                        <div className="thumblist">
                            <Image src={group.pic2 ? group.pic2 : "img/no-image.jpg"}
                                fallbackSrc="img/no-image.jpg" alt='' />
                            {/*<img*/}
                            {/*    src={group.pic2 ? group.pic2 : "img/no-image.jpg"}*/}
                            {/*    alt=" " />*/}
                            <Image src={group.pic3 ? group.pic3 : "img/no-image.jpg"}
                                fallbackSrc="img/no-image.jpg" alt='' />
                            {/*<img*/}
                            {/*    src={group.pic3 ? group.pic3 : "img/no-image.jpg"}*/}
                            {/*    alt=" " />*/}
                        </div>
                    </div>
                </ExtendedLink>
                <div className="card-body text-center d-flex flex-column justify-content-end">
                    <h4 className="card-title">{group.name}</h4>
                    {/* <p className="text-muted">Starting from £57.00</p> */}
                    <ExtendedLink
                        to={groupsLink}
                        className="btn btn-outline-primary btn-sm overflow-text"
                        href=""
                    >
                        {t("View Products")}
            </ExtendedLink>
                </div>
            </div>
        </div>
    );
}
